import { render, staticRenderFns } from "./RpManage.vue?vue&type=template&id=550aee86&scoped=true&"
import script from "./RpManage.vue?vue&type=script&lang=js&"
export * from "./RpManage.vue?vue&type=script&lang=js&"
import style0 from "./RpManage.vue?vue&type=style&index=0&id=550aee86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550aee86",
  null
  
)

export default component.exports